import Header from '../../.shared/header/header';
import Footer from '../../.shared/footer/footer';
import WelcomeHero from './WelcomeHero';
import WelcomeJourneyStrip from './WelcomeJourneyStrip';
import WelcomeActions from './WelcomeActions';
import LifeEventsCalculator from './LifeEventsCalculator';
import WelcomeCommunity from './WelcomeCommunity';
import WelcomeAffiliate from './WelcomeAffiliate';
import styles from './YourJourneyBegins.module.css';

function YourJourneyBegins() {
    return (
        <>
            <Header />
            <main className={styles.page}>
                <WelcomeHero />
                <WelcomeJourneyStrip />
                <WelcomeActions />
                <LifeEventsCalculator />
                <WelcomeCommunity />
                <WelcomeAffiliate />
            </main>
            <Footer />
        </>
    );
}

export default YourJourneyBegins;
